function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M0 85.331h512v341.337H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M178.923 189.567l14.656 45.107h47.429l-38.371 27.878 14.657 45.109-38.371-27.879-38.371 27.879 14.656-45.109-38.371-27.878h47.429zM271.3 339.593l-14.39-10.455-14.388 10.454 5.495-16.914-14.389-10.455h17.786l5.496-16.916 5.498 16.916h17.785l-14.389 10.454zm37.537-51.666h-17.785l-5.496 16.914-5.496-16.913-17.787-.001 14.391-10.455-5.498-16.915 14.39 10.453 14.389-10.453-5.496 16.915zm0-63.864l-14.388 10.455 5.495 16.914-14.388-10.453-14.39 10.455 5.498-16.917-14.391-10.452 17.788-.002 5.495-16.916 5.496 16.916zM271.3 172.397l-5.495 16.916 14.388 10.453-17.785.001-5.498 16.917-5.496-16.918-17.785.002 14.389-10.456-5.496-16.916 14.388 10.455z",
  fill: "#ffda44"
});

const SvgChina = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), _ref2, _ref3);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgChina, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/china.2496bf57.svg";
export { ForwardRef as ReactComponent };